// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingApplyToProjectMutationVariables = Types.Exact<{
  input: Types.ApplyProjectReadyPlanConfigsInput;
}>;


export type ProductOfferingApplyToProjectMutation = { __typename?: 'Mutation', applyProjectReadyPlanConfigs: { __typename?: 'ApplyProjectReadyPlanConfigsResult', projectReadyPlanConfigs: Array<{ __typename?: 'ProjectReadyPlanConfig', id: string, project: { __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string } }> } };


export const ProductOfferingApplyToProjectDocument = gql`
    mutation ProductOfferingApplyToProject($input: ApplyProjectReadyPlanConfigsInput!) {
  applyProjectReadyPlanConfigs(input: $input) {
    projectReadyPlanConfigs {
      id
      project {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export type ProductOfferingApplyToProjectMutationFn = Apollo.MutationFunction<ProductOfferingApplyToProjectMutation, ProductOfferingApplyToProjectMutationVariables>;

/**
 * __useProductOfferingApplyToProjectMutation__
 *
 * To run a mutation, you first call `useProductOfferingApplyToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingApplyToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productOfferingApplyToProjectMutation, { data, loading, error }] = useProductOfferingApplyToProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOfferingApplyToProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProductOfferingApplyToProjectMutation, ProductOfferingApplyToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProductOfferingApplyToProjectMutation, ProductOfferingApplyToProjectMutationVariables>(ProductOfferingApplyToProjectDocument, options);
      }
export type ProductOfferingApplyToProjectMutationHookResult = ReturnType<typeof useProductOfferingApplyToProjectMutation>;
export type ProductOfferingApplyToProjectMutationResult = Apollo.MutationResult<ProductOfferingApplyToProjectMutation>;
export type ProductOfferingApplyToProjectMutationOptions = Apollo.BaseMutationOptions<ProductOfferingApplyToProjectMutation, ProductOfferingApplyToProjectMutationVariables>;